import Events from "actions/events";

const SettingsReducer = (state = [], action) => {
  switch (action.type) {
    case Events.Settings.PRODUCTION_DEFAULT_RECEIVE:
      return {
    	  ...state,
    	  selectedProductionId : action.data
    	 }
    case Events.Settings.TAB_DEFAULT_RECEIVE:
        return {
    	...state,
    	selectedTabId : action.data
    }
    default:
      return state
  }
}

export default SettingsReducer;


// WEBPACK FOOTER //
// ./src/scripts/reducers/SettingsReducer.js